'use strict'

const services =  {
    init: function() {
        let btn = document.querySelector('.services_loadmore');
        if(btn)
            btn.addEventListener('click', function() {
                btn.parentElement.classList.add('loaded');
            });
    },
}


export default services;


// WEBPACK FOOTER //
// ./src/scripts/components/services.js